import { defaultEnvironment } from '../environment';
import { parseEmployee } from './employee';
import { HttpService } from './http';
const jerseyTypesMap = {
  distance: 'DISTANCE',
  consecutiveDaysCount: 'CONSECUTIVE_DAYS_COUNT',
  homeWorkJourneysCount: 'WORK_HOME_JOURNEYS_COUNT'
};
export class JerseyService {
  static async getJerseyLeaderboard({
    partner: {
      code: partner
    },
    groupId,
    type,
    page,
    pageSize,
    query,
    userId
  }) {
    try {
      const params = [{
        key: 'jersey_type',
        value: jerseyTypesMap[type]
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }, {
        key: 'exclude_null_progress',
        value: true
      }];
      if (query) params.push({
        key: 'query',
        value: query
      });
      if (userId) params.push({
        key: 'user_id',
        value: userId
      });
      const {
        count,
        results
      } = await HttpService.get('v1', `/groups/${groupId}/jersey_leaderboard`, params, [], null, {
        partner
      });
      const items = parseJerseyLeaderboard(results);
      return {
        count,
        items
      };
    } catch (err) {
      console.error('[JerseyService][getJerseyLeaderboard]', err);
      throw err;
    }
  }
  static async getJerseysHolders({
    partner: {
      code: partner
    },
    groupId,
    query
  }) {
    try {
      const params = [];
      if (query) params.push({
        key: 'query',
        value: query
      });
      const results = await HttpService.get('v1', `/groups/${groupId}/jersey_holder`, params, [], null, {
        partner
      });
      const leaderboard = parseJerseyLeaderboard(results);
      return leaderboard;
    } catch (err) {
      console.error('[JerseyService][getJerseysHolders]', err);
      throw err;
    }
  }
}
export const backendJerseyTypesMap = {
  DISTANCE: 'distance',
  CONSECUTIVE_DAYS_COUNT: 'consecutiveDaysCount',
  WORK_HOME_JOURNEYS_COUNT: 'homeWorkJourneysCount'
};
function parseJerseyLeaderboard(items) {
  return items.map(({
    jersey_type,
    has_jersey: hasJersey,
    leaderboard_index: leaderboardIndex,
    progress_value: progressValue,
    rank,
    user
  }) => ({
    type: backendJerseyTypesMap[jersey_type],
    hasJersey,
    leaderboardIndex,
    progressValue,
    rank,
    user: {
      ...user,
      profilePicture: user.profile_picture ? `${defaultEnvironment.backendUrl}${user.profile_picture}` : user.profile_picture,
      employee: user.employee[0] ? parseEmployee(user.employee[0]) : null
    }
  }));
}